import { defineComponent as _defineComponent } from 'vue'
import { useLazyAsyncData, useNuxtApp, useRoute } from '#app'
import { getNationalParks } from './fetch'


export default /*#__PURE__*/_defineComponent({
  __name: 'NationalParks',
  props: {
    withImage: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { withImage: boolean };



const route = useRoute()
const lang = route.params.lang || 'en-gb'
const { data: nationalParks } = useLazyAsyncData(
  `nationalParks-${lang}`,
  async () => {
    const { $route } = useNuxtApp()
    return await getNationalParks($route.params.lang || '')
  },
)

return { __sfc: true,props, route, lang, nationalParks }
}

})